import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M14.378 14.378a.375.375 0 0 1 .53 0l6.357 6.357a.375.375 0 0 1-.53.53l-6.357-6.357a.375.375 0 0 1 0-.53",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M10.125 4.125a6 6 0 1 0 0 12 6 6 0 0 0 0-12m-6.75 6a6.75 6.75 0 1 1 13.5 0 6.75 6.75 0 0 1-13.5 0",
		clipRule: "evenodd"
	})]
});
export default SvgSearch;
